<template>
    <button v-on:click="handleClick" :class="type">{{text}}</button>
</template>

<script>
    export default {
        name: "log-in-button",
        props: ['type', 'text', 'onClick'],
        mounted() {

        },
        rendered() {

        },
        methods: {
            handleClick: function (e) {
                e.preventDefault();
                this.$emit('login', this.type);
            }
        }
    }
</script>

<style scoped lang="scss">

</style>